/**
 * One labelled figure in a stat grid.
 *
 * Extracted after it had been written out three times and the copies had
 * quietly parted company: two rendered `note` as a visible caption line, and
 * the third passed it to `title` as a hover tooltip. Both are wanted —
 * `NetworkPanel` captions a figure ("issuance less the endowment"), while
 * `NodePanel` needs the untruncated form of a value behind a hover — so this
 * takes them as separate props rather than picking a winner and silently
 * changing one of the pages.
 *
 * The lesson is the one `isStandings` already records: a thing written out four
 * times is four things, and they diverge without anybody deciding to.
 */
export function Field({
  label,
  value,
  note,
  title,
}: {
  label: string
  value: string
  /** A caption under the figure. Visible. */
  note?: string | undefined
  /** The full text behind a hover, where the figure is abbreviated. */
  title?: string | undefined
}) {
  return (
    <div className="node-field">
      <div className="eyebrow">{label}</div>
      <div className="node-value" title={title}>
        {value}
      </div>
      {note && <div className="stat-note">{note}</div>}
    </div>
  )
}
